let realUFunc = null;

function load() {
  return import(/*webpackChunkName:"core_ufunc_async"*/ "./customMathematical");
}

const ufunc = function (formula) {
  return load().then((res) => {
    let uf = dsf.getEsModule(res);
    return uf(formula);
  });
};
ufunc.createFormulaCodeStr = function (astTree, callback, parent, isParams) {
  return load().then((res) => {
    let uf = dsf.getEsModule(res);
    return uf.createFormulaCodeStr(astTree, callback, parent, isParams);
  });
};
ufunc.readFormulaExpress = function (input) {
  return load().then((res) => {
    let uf = dsf.getEsModule(res);
    return uf.readFormulaExpress(input);
  });
};
export default ufunc;
